import React, { Component } from "react"
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import UIkit from 'uikit'
import * as Validator from '../../utils/helpers/validationPassword'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchUpdatePasswordMembersAction } from  '../../actions/Reglages/MembersData'

class ReglagesUserPassword extends Component {
  state = {
    passwordData : {
      password: "",
      newPassword: "",
      checkPassword: "",
      email: "",
    },
    notificationUpdateUserPasswordDataMembersError: false,
    notificationUpdateUserPasswordDataMembersSuccess: false,
    //notModificationDetected: false,
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Réglages du mot de passe`
    const { getReauthenticate, reauthenticateMembers } = this.props
    if (Object.keys(reauthenticateMembers.userData).length === 0) {
      getReauthenticate()
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (nextProps.updateUserPasswordDataMembers.isError !== this.props.updateUserPasswordDataMembers.isError) {
      this.setState({ notificationUpdateUserPasswordDataMembersError: nextProps.updateUserPasswordDataMembers.isError })
    }
    if (nextProps.updateUserPasswordDataMembers.isSuccess !== this.props.updateUserPasswordDataMembers.isSuccess) {
      this.setState({ notificationUpdateUserPasswordDataMembersSuccess: nextProps.updateUserPasswordDataMembers.isSuccess })
    }
  }
  handleSubmitPasswordData = event => {
    event.preventDefault()
    const { passwordData } = this.state
    const { checkUpdatePasswordDataMembers, reauthenticateMembers } = this.props

    if (Validator.verifyPasswordChar(passwordData.newPassword) && Validator.verifyPasswordLowcase(passwordData.newPassword) && Validator.verifyPasswordUppercase(passwordData.newPassword) && Validator.verifyPasswordNumber(passwordData.newPassword) &&
      Validator.verifyPasswordChar(passwordData.checkPassword) && Validator.verifyPasswordLowcase(passwordData.checkPassword) && Validator.verifyPasswordUppercase(passwordData.checkPassword) && Validator.verifyPasswordNumber(passwordData.checkPassword) &&
      passwordData.newPassword === passwordData.checkPassword && passwordData.password.length
      ) {
      checkUpdatePasswordDataMembers(passwordData.password, passwordData.newPassword, reauthenticateMembers.userData.email, reauthenticateMembers.userData._id)
    }else {
      //this.setState({ notModificationDetected: true })
    }
  }
  handleChangePasswordData = (event) => {
    const { passwordData } = this.state

    passwordData[event.target.name] = event.target.value
    this.setState({ passwordData })
  }
  NotificationUpdateUserPasswordDataMembersError = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Erreur mise à jour du mot de passe",
      status: 'danger',
      pos: 'top-center',
    })
    return <Redirect to='/reglages' push/>
  }
  NotificationUpdateUserPasswordDataMembersSuccess = () => {
    UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Succès mise à jour du mot de passe",
      status: 'success',
      pos: 'top-center',
    })
    return <Redirect to='/reglages' push/>
  }
  NotModificationDetected = () => {
    /*UIkit.notification({
      message: "<i class='fa fa-times-circle aps-section-notification-box-icon'></i> Mot de passe incorrect, réessayer ...",
      status: 'warning',
      pos: 'top-center',
    })
    this.setState({ notModificationDetected: false })*/
  }
  render() {
    const { match, reauthenticateMembers, updateUserPasswordDataMembers } = this.props
    const { notificationUpdateUserPasswordDataMembersError, notificationUpdateUserPasswordDataMembersSuccess } = this.state

    return (
      <div>
        <Header userIsSuccessLogin={reauthenticateMembers.isSuccess} />
          {reauthenticateMembers.isLoading
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-body-second-content">
                  <div className="aps-dashboard-body-container-title">
                    <p className="uk-text-center aps-dashboard-body-title">
                      Réglages de votre compte
                    </p>
                  </div>
                  <div className="aps-dashboard-body-container-reglages-desc">
                    <hr className="aps-btn-pre-header-divider" />
                  </div>
                  {/*Section informations User*/}
                  {(!reauthenticateMembers.isSuccess)
                      ?
                        <div className="aps-spinner-component-loading">
                          <div className="uk-spinner">
                            <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                               <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                            </svg>
                          </div>
                          <div className="aps-section-register-desc">chargement en cours</div>
                        </div>
                      :
                        <div>
                          <div className="aps-dashboard-body-container-reglages-desc aps-dashboard-body-container-reglages-show-web">
                            <div className="aps-dashboard-reglages-user-data">
                              <span className="aps-dashboard-reglages-user-data-attribut">Nom :</span>
                              <span className="aps-dashboard-reglages-user-data-value">
                                {reauthenticateMembers.userData.firstname && reauthenticateMembers.userData.firstname}
                              </span>
                              <span className="" style={{float: "right"}}>
                                <Link className="uk-button aps-btn-silver" to="/reglages-user-data">Modifier les informations</Link>
                              </span>
                            </div>
                            <div className="aps-dashboard-reglages-user-data-second aps-dashboard-reglages-padding-bottom">
                              <span className="aps-dashboard-reglages-user-data-attribut">Prénom :</span>
                              <span className="aps-dashboard-reglages-user-data-value" style={{paddingLeft: "20px"}}>
                                {reauthenticateMembers.userData.lastname && reauthenticateMembers.userData.lastname}
                              </span>
                            </div>
                          </div>
                          <div style={{display: "none"}} className="aps-dashboard-body-container-reglages-desc aps-dashboard-body-container-reglages-show-mobile">
                            <div className="aps-dashboard-reglages-user-data">
                              <div>
                                <span className="aps-dashboard-reglages-user-data-attribut">Nom :</span>
                                <span className="aps-dashboard-reglages-user-data-value">
                                {reauthenticateMembers.userData.firstname && reauthenticateMembers.userData.firstname}
                                </span>
                              </div>
                            </div>
                            <div className="aps-dashboard-reglages-user-data-second aps-dashboard-reglages-padding-bottom">
                              <div>
                                <span className="aps-dashboard-reglages-user-data-attribut">Prénom :</span>
                                <span className="aps-dashboard-reglages-user-data-value" style={{paddingLeft: "20px"}}>
                                  {reauthenticateMembers.userData.lastname && reauthenticateMembers.userData.lastname}
                                </span>
                              </div>
                              <div>
                                <span className="" style={{float: "right", paddingTop: "20px"}}>
                                  <Link className="uk-button aps-btn-silver" to="/reglages-user-data">Modifier les informations</Link>
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                  }
                  <div className="aps-dashboard-body-container-reglages-desc">
                    <hr className="aps-btn-pre-header-divider" />
                  </div>
                  {/*Section lost password*/}
                  <div className="aps-dashboard-body-container-reglages-desc">
                    <div className="aps-dashboard-reglages-user-data">
                      <span className="aps-dashboard-reglages-user-data-attribut">Mot de passe : </span>
                    </div>
                    <div className="aps-dashboard-reglages-user-data">
                      <span className="aps-dashboard-reglages-text-desc">Définissez un mot de passe unique pour protéger votre compte </span>
                    </div>
                  </div>
                  {/*Form Update Password*/}
                  {updateUserPasswordDataMembers.isLoading
                    ?
                      <div className="aps-spinner-component-loading">
                        <div className="uk-spinner">
                          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                             <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                          </svg>
                        </div>
                        <div className="aps-section-register-desc">chargement en cours</div>
                      </div>
                    :
                      <div className="aps-dashboard-reglages-container-mobile-form">
                        <div className="aps-section-resgister-souscripteur-form">
                          {updateUserPasswordDataMembers.isError && notificationUpdateUserPasswordDataMembersError &&
                            <div>
                              { this.NotificationUpdateUserPasswordDataMembersError() }
                            </div>
                          }
                          {updateUserPasswordDataMembers.isSuccess && notificationUpdateUserPasswordDataMembersSuccess &&
                            <div>
                              { this.NotificationUpdateUserPasswordDataMembersSuccess() }
                            </div>
                          }
                          <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">Votre mot de pass actuel</p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <input onChange={(event) => this.handleChangePasswordData(event)} type="password" className="uk-input aps-section-register-fields" placeholder="Ancien mot de passe" name="password" />
                            </div>
                          </div>
                          <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">Votre nouveau mot de passe</p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <input onChange={(event) => this.handleChangePasswordData(event)} type="password" className="uk-input aps-section-register-fields" placeholder="Nouveau mot de passe" name="newPassword" />
                            </div>
                          </div>
                          <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-center">
                            <p className="uk-text-left aps-section-contacter-fields-name">Confirmer nouveau mot de passe</p>
                            <div className="uk-inline aps-section-register-fields-full">
                              <input onChange={(event) => this.handleChangePasswordData(event)} type="password" className="uk-input aps-section-register-fields" placeholder="Comfirmer le mot de passe" name="checkPassword" />
                            </div>
                          </div>
                          <div className="aps-section-resgister-souscripteur-fields-center aps-section-register-fields-one uk-text-right">
                            <Link className="uk-button aps-btn-silver" to="/reglages">Annuler</Link>
                            <Link className="uk-button aps-btn-green" to={{hash: "#"}} onClick={(event) => this.handleSubmitPasswordData(event)}>Valider</Link>
                          </div>
                        </div>
                      </div>
                  }
                  <div className="aps-dashboard-body-container-reglages-desc">
                    <hr className="aps-btn-pre-header-divider" />
                  </div>
                  {reauthenticateMembers.isError &&
                    <div>
                      <Redirect to='/connexion' push/>
                    </div>
                  }
                </div>
              </Dashboard>
            }
        <Footer />
      </div>
      )
    }
  }
  const mapStateToProps = ({ reauthenticateMembers, updateUserPasswordDataMembers }) => {
    return {
      reauthenticateMembers,
      updateUserPasswordDataMembers,
    }
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
      checkUpdatePasswordDataMembers: (password, newPassword, email, userID) => dispatch(fetchUpdatePasswordMembersAction(password, newPassword, email, userID)),
    }
  }

  export default connect(mapStateToProps, mapDispatchToProps)(ReglagesUserPassword)



// WEBPACK FOOTER //
// ./src/containers/ReglagesUserPassword/index.js